package com.mrpowergamerbr.puppydough.webtale

import kotlinx.serialization.Serializable

@Serializable
data class WebtaleConfig(
    val versions: List<GameVersion>,
    val activeVersion: String?
) {
    @Serializable
    data class GameVersion(
        val id: String,
        val name: String,
        val gameWADName: String,
    )
}